import { render } from "./process-create-import.vue?vue&type=template&id=c91a42fa"
import script from "./process-create-import.vue?vue&type=script&lang=js"
export * from "./process-create-import.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__